<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VF2MFm/tc-custom/9780470446539.jpg?1705031865498" alt="This image is the cover for the book Effective Software Project Management"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Effective Software Project Management
      </h1>
      <p class="bookDescription body article font2">
        <p>Why another book on software project management?      For some time, the fields of project management, computer science,  and software development have been growing rapidly and  concurrently. Effective support for the enterprise demands the  merging of these efforts into a coordinated discipline, one that  incorporates best practices from both systems development and  project management life cycles. Robert K. Wysocki creates that  discipline in this book--a ready reference for professionals and  consultants as well as a textbook for students of computer  information systems and project management.    By their very nature, software projects defy a "one size fits all"  approach. In these pages you will learn to apply best-practice  principles while maintaining the flexibility that's essential for  successful software development.    Learn how to make the planning process fit the need  * Understand how and why software development must be planned on a  certainty-to-uncertainty continuum  * Categorize your projects on a four-quadrant model  * Learn when to use each of the five SDPM strategies--Linear,  Incremental, Iterative, Adaptive, and Extreme  * Explore the benefits of each strategic model and what types of  projects it supports best  * Recognize the activities that go into the Scoping, Planning,  Launching, Monitoring/Controlling, and Closing phases of each  strategy  * Apply this knowledge to the specific projects you manage  * Get a clear picture of where you are and how to get where you  want to go</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert K. Wysocki
      </h2>
      
      <p class="authorDescription body article">ROBERT K. WYSOCKI, PHD, is a veteran consultant, trainer, and information systems manager with more than 40 years in the field. He is the author of the bestselling Effective Project Management: Traditional, Adaptive, Extreme, Third Edition (Wiley) and 13 other books. His client list includes AT&T, Eli Lilly & Co., the Czechoslovakian government, and the U.S. Coast Guard Academy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wiley
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8346c814